"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRouterDom = require("react-router-dom");
var _material = require("@mui/material");
var _core = require("@focaltec-suite/core");
var _ExpandLessTwoTone = _interopRequireDefault(require("@mui/icons-material/ExpandLessTwoTone"));
var _ExpandMoreTwoTone = _interopRequireDefault(require("@mui/icons-material/ExpandMoreTwoTone"));
var _Translator = _interopRequireDefault(require("../i18n/Translator"));
var _RouteList = _interopRequireDefault(require("./RouteList"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var CustomListItemIcon = (0, _material.styled)(_material.ListItemIcon)(function (_ref) {
  var theme = _ref.theme;
  return {
    minWidth: '40px'
  };
});
function RouteListItem(_ref2) {
  var index = _ref2.index,
    route = _ref2.route,
    inner = _ref2.inner;
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    open = _useState2[0],
    setOpen = _useState2[1];
  var layoutContext = (0, _react.useContext)(_core.LayoutContext);
  if (route.path) {
    return /*#__PURE__*/_react["default"].createElement(_material.ListItemButton, {
      key: index,
      onClick: layoutContext.closeDrawer,
      component: _reactRouterDom.Link,
      to: route.path,
      sx: inner ? {
        pl: 4
      } : undefined
    }, /*#__PURE__*/_react["default"].createElement(CustomListItemIcon, null, route.icon), /*#__PURE__*/_react["default"].createElement(_material.ListItemText, {
      primary: (0, _Translator["default"])(route.title),
      primaryTypographyProps: {
        variant: 'body1'
      }
    }));
  }
  return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_material.ListItemButton, {
    key: index,
    onClick: function onClick() {
      return setOpen(!open);
    }
  }, /*#__PURE__*/_react["default"].createElement(CustomListItemIcon, null, route.icon), /*#__PURE__*/_react["default"].createElement(_material.ListItemText, {
    primary: (0, _Translator["default"])(route.title),
    primaryTypographyProps: {
      variant: 'body1'
    }
  }), open ? /*#__PURE__*/_react["default"].createElement(_ExpandLessTwoTone["default"], null) : /*#__PURE__*/_react["default"].createElement(_ExpandMoreTwoTone["default"], null)), route.items && route.items.length > 0 && (/*#__PURE__*/_react["default"].createElement(_material.Collapse, {
    "in": open,
    timeout: "auto",
    unmountOnExit: true
  }, /*#__PURE__*/_react["default"].createElement(_RouteList["default"], {
    routes: route.items,
    inner: true
  }))));
}
var _default = exports["default"] = /*#__PURE__*/(0, _react.memo)(RouteListItem);